module.exports = wp.editPost;